import { DownloadOutlined, MessageOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { getListOfMessages, Message } from '../../api/NetworkingMessages';
import { getResource } from '../../helpers/ResourcesHelper';
import DataGrid from '../table/DataGrid';
import MessageContent from './messages/MessageContent';

const MyMessages = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [updating, setUpdating] = useState(false);
  const [viewMessageContent, setViewMessageContent] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState<Message | null>(null);

  useEffect(() => {
    const loadMessages = async () => {
      const json = await getListOfMessages();
      if (json != null && json.messages != null) {
        setMessages(json.messages);
      }
    };
    loadMessages();
  }, [updating]);

  const selectMessageToReply = (record: Message) => {
    setSelectedMessage(record);
    setViewMessageContent(true);
  };

  const handleBackLink = () => {
    setSelectedMessage(null);
    setViewMessageContent(false);
    setUpdating(!updating);
  };

  const columns = [
    {
      title: getResource('Table_TH_Subject'),
      dataIndex: 'Subject',
      key: 'subject',
      align: 'center'
    },
    {
      title: getResource('Table_TH_Sender'),
      dataIndex: 'Sender',
      key: 'sender',
      align: 'center'
    },
    {
      title: getResource('Table_TH_Date'),
      dataIndex: 'SentOn',
      key: 'sentOn',
      align: 'center'
    },
    {
      title: getResource('Table_TH_Action'),
      key: 'action',
      align: 'center',
      render: (_: any, record: Message) => (
        <div>
          <Tooltip title={getResource('Js_Link_ViewMessage')}>
            <Typography.Link onClick={() => selectMessageToReply(record)}>
              <MessageOutlined style={{ fontSize: 18 }} />
            </Typography.Link>
          </Tooltip>
        </div>
      )
    }
  ];

  if (viewMessageContent) {
    return <MessageContent message={selectedMessage} handleBackLink={handleBackLink} />;
  }

  return (
    <div className="row center-xs">
      <DataGrid className="col-md-6 slide-r-l" columns={columns} dataSource={messages}
        exportableProps={{
          fileName: 'MyMessages',
          btnProps: {
            type: "default",
            icon: <DownloadOutlined />,
          }
        }} />
    </div>
  );
};

export default MyMessages;
